import React, { useState, useEffect, useRef } from "react";
//REACT-BOOTSTRAP
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
//CHILD COMPONENTS
import FilterDefaultDropdown from "../filter-panel/Fitler-Default-Dropdown";
import ToggleAll from "../Toggle-All-Row/Toggle-All-Row";

//loader
import { PulseLoader } from "react-spinners";
//Redux
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import "../filter-panel/filter-panel.scss";
import "./filter-sort-panel.scss";
import { selectTaskQuery } from "../../redux/tasks/task-selector";
import { selectUserID } from "../../redux/user/user-selector";
import ClearSortActive from '../../assets/icons/ClearSortActive-32px-Blue-60.svg';
import ClearSortDisabled from '../../assets/icons/ClearSortDisabled-32px-Gray-70.svg';
import ClearFiltersActive from '../../assets/icons/ClearFiltersActive-32px-Blue-60.svg';
import ClearFiltersDisabled from '../../assets/icons/ClearFiltersDisabled-32px-Gray-70.svg';
import SortAscending from '../../assets/icons/SortAsc-32px-Blue-60.svg';
import SortDescending from '../../assets/icons/SortDesc-32px-Blue-60.svg';
import SortActive from '../../assets/icons/SortActive-32px-Blue-60.svg';
import IsSortedDesc from '../../assets/icons/IsSortedDesc-32px-Gray-70.svg';
import IsSortedAsc from '../../assets/icons/IsSortedAsc-32px-Gray-70.svg';
import IsFiltered from '../../assets/icons/IsFiltered-32px-Gray-70.svg';
import ClearSearchFilter from '../../assets/icons/Icon - X - Blue.svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


//POTENTIAL WAY TO MAKE MORE EFFICIENT- MAKE FILTERPANEL A DIV ON CLICK SO THE PANEL HTML/CSS IS MORE REUSABLE
const FilterSortPanel = ({
  header,
  type,
  close,
  selected,
  save,
  clear,
  updateSelected,
  change,
  filterIcon,
  adminPayload,
  selectedSortType,
  fieldId,
  parentFieldId,
  //redux
  taskQuery,
  userID,
  filterPayload = []
}) => {
  const [payload, setPayload] = useState([]);
  const [showFilter, setShowFilter] = useState(false); //Will always be false when this is called, changed internally in useEffects
  //SEARCHBAR STRING
  const [searchFilter, setSearchFilter] = useState("");
  //RENDERED ROWS
  const [rowFilter, setRowFilter] = useState([]);
  //CHECKED ROWS
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsCounter, setSelectedRowsCounter] = useState(0);
  //CHANGING VARIABLES AND CLASSNAMES DEPENDING ON TYPE FOR LOGIC AND STYLING
  const [nameClass, setNameClass] = useState("");
  const [idParam, setIDParam] = useState("");
  const [nameParam, setNameParam] = useState("");
  //LOADING VARIABLE
  const [isLoading, setIsLoading] =  useState(false);
  //ALL XXX
  const [allTitle] = useState("");
  //SPECIFIC TO TYPES COLUMN
  const [dropdownTrigger] = useState(true);
  const [isSortingAscending, setIsSortingAscending] = useState(false);
  const [isSortingDescending, setIsSortingDescending] = useState(false);
  const [dropdownIcon, setDropdownIcon] = useState(filterIcon);
  const [menuHeight, setMenuHeight] = useState(0);
  const [menuWidth, setMenuWidth] = useState(0);
  const [menuId, setMenuId] = useState(0);
  const [currentScroll, setCurrentScroll] = useState(0);
  //HANDLES MOUSE CLICKS OUTSIDE OF ELEMENT
  const ref = useRef();

  const handleClick = (e) => {
    if (ref.current.contains(e.target) || e.target.className == "clearFiltersBtnHidden") {
      // inside click
      return;
    }
    closeFilter();
  };

  useEffect(() => {
    // add when mounted
    document.addEventListener("click", handleClick); // return function to be called when unmounted
    let elements = document.getElementsByClassName("dropdownToggle");
    for (let i = 0; i < elements.length; i++) {
      elements[i].addEventListener('click', getClickPosition, false);
    }
    // let elements2 = document.getElementsByClassName("dynamicTableContainer");
    // for (let j = 0; j < elements2.length; j++) {
    //   elements2[j].addEventListener('scroll', adjustScroll, false);
    // }
    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("click", getClickPosition);
    };

  }, []);

  useEffect(() => {
  
    if(showFilter){
      setTimeout(() => {
        let dropMenu = document.getElementById("menu-"+menuId);
        dropMenu.style.cssText =  `top : ${menuHeight}px !important; left : ${menuWidth}px !important`;
        document.addEventListener('scroll',adjustScroll,false);
      }, 0);   
  }
  }, [showFilter]);

  const adjustScroll = (e) =>{
    let yPosition = 0;
    // let xPosition = 0;
    let yScrollPos = document.documentElement.scrollTop;    
    // let x = document.getElementsByClassName("dynamicTableContainer");
    // let xScrollPos = x[0].scrollLeft;
    yPosition += (menuHeight - yScrollPos + currentScroll);
    // xPosition += (menuWidth - xScrollPos);
    let dropMenu = document.getElementById("menu-"+menuId);
    // var a= document.getElementsByClassName("filterMenu");
    if(dropMenu != null ){
      dropMenu.style.cssText =  `top : ${yPosition}px !important; left : ${menuWidth}px !important`;
    }
  }

  const getClickPosition = (e) => { 
    if(e.target !== e.currentTarget)
      return;
    var xPosition = e.clientX;
    var yPosition = e.clientY;
    let mId= e.target.id.split('_');
    setMenuId(mId[1]);
    let scrollCurrent = document.documentElement.scrollTop;
    let windowWidth =document.documentElement.offsetWidth;
    if(xPosition+480>windowWidth)
      xPosition=xPosition-470;
    setMenuHeight(yPosition);
    setMenuWidth(xPosition);
    setCurrentScroll(scrollCurrent);     
  }

  //SEARCH BAR FUNCTIONALITY
  useEffect(() => {
    let newFilter = [];
    if (searchFilter != "") {
      newFilter = payload.filter((row) =>
        row[nameParam].toLowerCase().includes(searchFilter.toLowerCase())
      );
      setSelectedRows(newFilter.map(r => r))
    } else {
      newFilter = payload; //resets rows
      toggleRow(payload, true)
    }

    setRowFilter(newFilter);
  }, [searchFilter]);

  //UPDATE ROWS COUNTER WHENEVER THE SELECTEDROWS ARRAY CHANGES
  useEffect(() => {
    setSelectedRowsCounter(selectedRows.length);
  }, [selectedRows]);

  useEffect(() => {
    setRowFilter(payload);
  }, [payload]);

  useEffect(() => {
    if(selectedSortType != type){
        clearSorts();

        if(selected.length > 0 && selected.length < payload.length) {
            setDropdownIcon(IsFiltered)
        }
        else {
            setDropdownIcon(filterIcon)
        }
    }
    else if(isSortingAscending){
        setDropdownIcon(IsSortedAsc)
    }
    else if(isSortingDescending){
        setDropdownIcon(IsSortedDesc)
    }
  }, [selectedSortType, selected]);

  const handleClickAscendingSort = () => {
    if(isSortingDescending){
        setIsSortingDescending(false)
        setIsSortingAscending(true);
    }
    else {
        setIsSortingAscending(!isSortingAscending);
    }
  }

  const handleClickDescendingSort = () => {
    if(isSortingAscending){
        setIsSortingAscending(false)
        setIsSortingDescending(true);
    }
    else {
        setIsSortingDescending(!isSortingDescending);
    }
  }

  const clearSorts = () => {
    setIsSortingAscending(false)
    setIsSortingDescending(false);
  }

  const clearSelectedRows = () => {
    toggleRow(payload, true)
  }
  
  const getPayload = async () => {
    change();
    if (!showFilter) {
      setShowFilter(true);
      setIsLoading(true);
      setIDParam('FieldValue');
      setNameParam('FieldValue');
      setSelectedRows(adminPayload.map(r => r));
      setPayload(adminPayload);
      setIsLoading(false);

    } else {
      setShowFilter(false);
      close();
    }
  };

  //CALLED WHEN USER SELECTS A ROW
  //ADDS CHECKED ROW TO SELECTEDROWS VARIABLE AND REMOVES UNCHECKED ROW
  const toggleRow = (chosen, checked) => {
    let chosenRow = [];
    if (checked) {
      //HANDLES ARRAYS FOR TYPES AND FOR ADDING FILTER
      chosenRow = selectedRows;
      Array.isArray(chosen)
        ? chosenRow.push(...chosen)
        : chosenRow.push(chosen);
      //NEED TO REMOVE ALL DUPLICATES
      let chosenSet = new Set(chosenRow)
      chosenRow = [...chosenSet]

      } else {
      //WHEN CHOSEN IS EMPTY
      if (chosen.length === 0) {
        chosenRow = [];
      } else {
        const index = selectedRows.indexOf(chosen);
        chosenRow = selectedRows;
        chosenRow.splice(index, 1);
      }
    }
    setSelectedRows(chosenRow);
    setSelectedRowsCounter(selectedRows.length); //for counter
  };

  //ONSUBMIT
  const saveFilter = () => {
    updateSelected(selectedRows, type);
    let ids = [];
    ids = selectedRows.map((row) => row[idParam]);
    
    //THESE ARE ARRAYS BECAUSE MEMBERS HAS CHANCE OF MAKING 2 COLUMNS
    let colName = [];
    let idFieldName = [];
    //NEW COLUMN(S) FOR FILTERS
    let newFilter = [];
    //SETTING NAMES OF FILTER FIELDS
    colName.push(type);
    idFieldName.push('fieldValue')
    let sortDirection = '';

    if(isSortingAscending){
      sortDirection = 'ASC';
    }
    else if(isSortingDescending){
      sortDirection = 'DESC';
    }

    //ADDING COLUMNS TO FILTERS
    for (let i = 0; i < colName.length; i++) {
      let fieldName = idFieldName[i];
      if (colName[i] === "taskName") {
        //temporary solution
        newFilter.push({
          column: colName[i],
          [fieldName]: ids,
          workitemIDs: ids,
        });
      } else {
        newFilter.push({
          column: colName[i],
          [fieldName]: ids,
        });
      }
    }
    if (ids.length < 1) {
      setSelectedRowsCounter(0);
      setSelectedRows([]);
      setRowFilter([]);
      setPayload([]);
      clear(type); //if you apply 0 filters, it will get rid of all filters
      save([], type, sortDirection);
    } else {
      save(newFilter, type, sortDirection);
    }

    if(sortDirection === 'ASC'){
        setDropdownIcon(IsSortedAsc)
    }
    else if(sortDirection === 'DESC'){
        setDropdownIcon(IsSortedDesc)
    }
    else if(newFilter.length > 0){
        setDropdownIcon(IsFiltered)
    }
    else {
        setDropdownIcon(filterIcon)
    }
    closeFilter();
  };
  //ON CANCEL
  const clearFilter = (e) => {
    updateSelected([], type);
    setSelectedRowsCounter(0);
    setSelectedRows([]);
    setRowFilter([]);
    setPayload([]);
    clear(type);
    clearSorts();
    setDropdownIcon(filterIcon);
    closeFilter();
  };

  const clearSearchFilter = (e) => {
    e.stopPropagation();
    setSearchFilter("");
  }
  //CLOSES FILTER
  const closeFilter = () => {
    setShowFilter(false);
    setSearchFilter("");
    setSelectedRows(selected);
    close();
  };

  //////////////////////////
  //SPECIFIC TO TYPES COLUMN
  //////////////////////////

  //TOGGLES DROPDOWN STYLING FOR TYPES FILTER PANEL
  useEffect(() => {
    if (type === "Types") {
      if (dropdownTrigger === false) {
        setNameClass("-types-no-drop");
      } else {
        setNameClass("-types");
      }
    }
  }, [dropdownTrigger]);

  return (
    <span className="filter-sort">
      <Dropdown show={showFilter} drop={"down"} flip={false} ref={ref} className="filter-sort-button-dropdown">
        <Dropdown.Toggle
          id={`img_${fieldId}`}
          class="dropdownToggle"
          style={{cursor: 'pointer'}}
          as={"img"}
          src={dropdownIcon}
          alt="filter-arrow"
          onClick={() => getPayload()}
        ></Dropdown.Toggle>
        {
          //MENU IS A BIT HIGHER THAN I THOUGHT, CAN'T SEEM TO MOVE DOWN
        }
        <Dropdown.Menu flip={true} className="filterMenu" id={"menu-" + fieldId}>
          {(isLoading) ? (
            <div
              style={{
                width: "478px",
                height: "441px",
                textAlign: "center",
                paddingTop: "220px",
              }}
            >
              <PulseLoader></PulseLoader>
            </div>
          ) : (
              <div className={`filter-sort-panel-dropdown`}>
                <div className="sort-panel">
                    <Dropdown.Header
                        className={`filter-sort-panel-title`}
                        onClick={clearSorts}
                    >
                        Sort
                      <OverlayTrigger
                          placement={"bottom"}
                          delay={{ show: 150, hide: 150 }}
                          overlay={
                              <Tooltip>
                                  Clear Sort
                              </Tooltip>
                          }
                      >
                          <div 
                              className="clearSortButton"
                          >
                              <img 
                                  className='clearFiltersBtnShowed'
                                  src={(isSortingAscending || isSortingDescending) ? ClearSortActive : ClearSortDisabled} 
                                  alt="Clear Sort"/>
                          </div>
                      </OverlayTrigger>
                    </Dropdown.Header>

                    <div className="sort-buttons-container">
                      <div className={isSortingAscending ? "sort-button-dropdown-active" : "sort-button-dropdown"}
                          onClick={handleClickAscendingSort}
                      >
                        <div className="sort-img-container">
                            <img 
                                className='sort-img'
                                src={SortAscending} 
                                alt="Clear Sort"
                            />
                            Sort ascending
                        </div>
                        <div className="sort-active-label">
                            <img 
                                className={isSortingAscending ? 'sort-label clearFiltersBtnActive' : 'sort-label clearFiltersBtnHidden'}
                                src={SortActive} 
                                alt="Active"
                            />
                        </div>
                        </div>

                      <div className={isSortingDescending ? "sort-button-dropdown-active" : "sort-button-dropdown"}
                          onClick={handleClickDescendingSort}
                      >
                        <div className="sort-img-container">
                            <img 
                                className='sort-img'
                                src={SortDescending} 
                                alt="Clear Sort"
                            />
                            Sort descending
                        </div>
                        <div className="sort-active-label">
                            <img 
                                className={isSortingDescending ? 'sort-label clearFiltersBtnActive' : 'sort-label clearFiltersBtnHidden'}
                                src={SortActive} 
                                alt="Active"
                            />
                        </div>
                      </div>
                    </div>
                </div>
                <Dropdown.Divider
                        style={{ width: "478px" }}
                ></Dropdown.Divider>

                <div className={`filter-panel-dropdown-top-container${nameClass}`}>
                  <Dropdown.Header
                      className={`filter-sort-panel-title`}
                  >
                    Filter
                    <OverlayTrigger
                      placement={"bottom"}
                      delay={{ show: 150, hide: 150 }}
                      overlay={
                          <Tooltip>
                              Clear Filter
                          </Tooltip>
                    }>
                      <div 
                        className="clearSortButton"
                        onClick={clearSelectedRows}>
                          <img 
                              className='clearFiltersBtnShowed'
                              src={selectedRowsCounter === rowFilter.length ? ClearFiltersDisabled : ClearFiltersActive} 
                              alt="Clear Filter"/>
                      </div>
                    </OverlayTrigger>
                  </Dropdown.Header>
                  <div className="searchbar-container">
                      <Form.Control
                          id={"searchbar-"+fieldId}
                          className={`filter-sort-panel-searchbar`}
                          as="textarea"
                          rows="1"
                          value={searchFilter}
                          onChange={(e) => setSearchFilter(e.target.value)}
                      >
                      </Form.Control>
                      { 
                        <div 
                          className="clearSearchbarButton"
                          onClick={(e) => clearSearchFilter(e)}>
                            <img 
                                className={searchFilter && searchFilter.length > 0 ? 'clearFiltersBtnShowed':'clearFiltersBtnHidden'}
                                src={ClearSearchFilter} 
                                alt="Clear Search bar"/>
                        </div>
                      }
                  </div>
                </div>
                <Form>
                  {
                    //DEFAULT DROPDOWN
                    <div className="filter-sort-panel-dropdown-default-container">
                      <Dropdown.Divider
                        style={{ width: "478px" }}
                      >
                      </Dropdown.Divider>
                      <ToggleAll
                        type={allTitle}
                        toggleAllRows={toggleRow}
                        payload={payload}
                        rows={selectedRows}
                        rowFilter={rowFilter}
                        checkedByDefault={true}
                      ></ToggleAll>
                      <Dropdown.Divider
                        style={{ width: "478px" }}
                      ></Dropdown.Divider>
                      {rowFilter &&
                      rowFilter.map((row) => (
                        <FilterDefaultDropdown
                          row={row}
                          nameParam={nameParam}
                          selectedRows={selectedRows}
                          toggleRow={toggleRow}
                          rowFilter={rowFilter}
                          idParam={idParam}
                        ></FilterDefaultDropdown>
                      ))}
                    </div>
                    
                  }
                  <div className={`filter-panel-button-container${nameClass}`}>
                    <input
                      type={"button"}
                      variant="outline-primary"
                      onClick={(e) => {
                        if(selectedRowsCounter == 0 && !isSortingAscending && !isSortingDescending){
                            return;
                        }
                        clearFilter(e);
                      }}
                      className={selectedRowsCounter == 0 && !isSortingAscending && !isSortingDescending ? "filter-sort-panel-clear-button-disabled" : "filter-sort-panel-clear-button"}     
                      value={"Clear All"}
                      ></input>
                      <input
                      type={"button"}
                      onClick={() => {
                          if(selectedRowsCounter == 0 && !isSortingAscending && !isSortingDescending){
                              return;
                          }
                          saveFilter();
                      }}
                      value={"Apply"}
                      className={selectedRowsCounter == 0 && !isSortingAscending && !isSortingDescending ? "filter-panel-apply-button-disabled" : "filter-panel-apply-button"}
                      ></input>
                  </div>
                </Form>
              </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </span>
  );
};

const mapState = createStructuredSelector({
  taskQuery: selectTaskQuery,
  userID: selectUserID,
});

export default connect(mapState, null)(FilterSortPanel);
